

























































































import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import { purify } from '~/directives/purify-html';
import { useProductContext } from '~/features/productContext';
import { useStoreConfig } from '~/features/storeConfig';

export default defineComponent({
  name: 'ProductPageDetails',
  directives: {
    purify,
  },
  setup() {
    const { product } = useProductContext();
    const expanded = ref<'features' | 'specs' | 'returns' | 'reviews' | null>(null);
    const attributes = computed(() => {
      return product.value.attributes;
    });
    const specs = ref('specs');
    const feature = ref('features');
    const { shippingLeadTime } = useStoreConfig();
    return {
      attributes,
      features: product.value.description?.html,
      expanded,
      product,
      specs,
      feature,
      shippingLeadTime,
    };
  },
});
